import { t } from '@lingui/core/macro';
import FilterBarLayout from '@duke-hq/filters/components/FilterBarLayout';
import ProviderFilter from './components/admin/ProviderFilter';
import CourseFilter from './components/admin/CourseFilter';
import HealthFilter from './HealthFilter';
import IssueFilter from './components/admin/IssueFilter';
import RecentPaceStatusFilter from './RecentPaceStatusFilter';
import ConsultantFilter from './components/admin/ConsultantFilter';
import LocationsFilter from './components/admin/LocationsFilter';
import ContractTypeFilter from '@duke-hq/filters/components/ContractTypeFilter';

export default function AdminFilterBar() {
  return (
    <FilterBarLayout
      filtersLabel={t`Filters`}
      clearAllLabel={t`Clear All`}
      moreFiltersLabel={t`More filters`}
    >
      <ProviderFilter key="provider" />
      <ConsultantFilter key="consultant" />
      <LocationsFilter key="locations" />
      <CourseFilter key="course" />
      <ContractTypeFilter key="contractType" />
      <HealthFilter key="health" />
      <RecentPaceStatusFilter key="recentPaceStatus" />
      <IssueFilter key="issue" />
    </FilterBarLayout>
  );
}
